import {useEffect, useId, useRef, useState} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ManualPopover} from "@pg-design/floating-module";
import {ChevronDownIcon, HeartFillIcon, HeartIcon} from "@pg-design/icons-module";

import {ViewType} from "../../view_type/ViewType";
import {trackFavouritesIconClick} from "../tracking/track_favourites_icon_click";
import {IFavouritesTopbarCard} from "../utils/map_favourite_to_topbar_card";
import {consumePendingFavouritesTopbar} from "../utils/pending_favourites_auth";
import {FavouritesCountBadge} from "./FavouritesCountBadge";
import {FavouritesTopbarDropdown} from "./FavouritesTopbarDropdown";

interface IProps {
    badgeTestId: string;
    buttonTestId: string;
    count: number;
    favouriteLabel: string;
    favouritesListLink: string;
    isAuthenticated: boolean;
    onGuestClick: () => void;
    cards: IFavouritesTopbarCard[];
    showBadge: boolean;
    viewType: ViewType | null;
}

export const FavouritesTopbarDesktop = (props: IProps) => {
    const {badgeTestId, buttonTestId, cards, count, favouriteLabel, favouritesListLink, isAuthenticated, onGuestClick, showBadge, viewType} = props;
    const [isOpen, setIsOpen] = useState(false);
    const dropdownId = useId();
    const rootRef = useRef<HTMLDivElement>(null);
    const triggerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!isAuthenticated) {
            return;
        }

        if (!consumePendingFavouritesTopbar("desktop")) {
            return;
        }

        setIsOpen(true);
    }, [isAuthenticated]);

    useEffect(() => {
        if (!isOpen) {
            return;
        }

        const onPointerDown = (event: PointerEvent) => {
            if (!(event.target instanceof Node) || rootRef.current?.contains(event.target)) {
                return;
            }

            setIsOpen(false);
        };

        const onKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Escape") {
                setIsOpen(false);
                triggerRef.current?.querySelector("button")?.focus();
            }
        };

        document.addEventListener("pointerdown", onPointerDown);
        document.addEventListener("keydown", onKeyDown);

        return () => {
            document.removeEventListener("pointerdown", onPointerDown);
            document.removeEventListener("keydown", onKeyDown);
        };
    }, [isOpen]);

    const handleDesktopButtonClick = () => {
        if (!isAuthenticated) {
            trackFavouritesIconClick();
            onGuestClick();
            return;
        }

        if (!isOpen) {
            trackFavouritesIconClick();
        }

        setIsOpen((open) => !open);
    };

    return (
        <div ref={rootRef}>
            <ManualPopover
                className={dropdownStyle}
                handleSetIsOpen={setIsOpen}
                hideArrow
                isOpen={isOpen}
                placement="bottom-end"
                popover={
                    <FavouritesTopbarDropdown cards={cards} count={count} dropdownId={dropdownId} favouritesListLink={favouritesListLink} viewType={viewType} />
                }
            >
                {({refs, getReferenceProps}) => (
                    <div
                        {...getReferenceProps()}
                        className={desktopTriggerStyle}
                        onClick={(event) => event.stopPropagation()}
                        ref={(node) => {
                            refs.setReference(node);
                            triggerRef.current = node;
                        }}
                    >
                        <Button
                            aria-controls={dropdownId}
                            aria-expanded={isOpen}
                            aria-haspopup="true"
                            aria-label={favouriteLabel}
                            className={desktopButtonStyle}
                            contentClassName={desktopButtonContentStyle}
                            dataTestId={buttonTestId}
                            iconLeft={isOpen ? HeartFillIcon : HeartIcon}
                            iconLeftProps={{
                                fill: "var(--colors-gray-800)",
                                size: "2.4",
                                wrapperColor: "var(--colors-beige-subtle)",
                                wrapperSize: "3.6",
                                wrapperType: "circle"
                            }}
                            iconRight={ChevronDownIcon}
                            iconRightProps={{
                                className: cx(chevronStyle, isOpen && chevronOpenStyle),
                                size: "1",
                                wrapperColor: "var(--colors-white)",
                                wrapperSize: "1.6",
                                wrapperType: "square"
                            }}
                            onClick={handleDesktopButtonClick}
                            type="button"
                            variant="transparent"
                        />
                        {showBadge && <FavouritesCountBadge count={count} dataTestId={badgeTestId} />}
                    </div>
                )}
            </ManualPopover>
        </div>
    );
};

const desktopTriggerStyle = css({
    position: "relative"
});

const desktopButtonStyle = css({
    h: "4rem",
    py: 0,
    pl: 0,
    pr: 2,
    bg: "var(--colors-white)",
    border: "1px solid var(--colors-gray-400)",
    borderRadius: "100px"
});

const desktopButtonContentStyle = css({
    gap: 1,
    "& > span:empty": {
        display: "none"
    }
});

const chevronStyle = css({
    borderRadius: "0.2rem",
    boxShadow: "var(--shadow-1)",
    "& svg": {
        transition: "transform 0.2s ease-in-out"
    }
});

const chevronOpenStyle = css({
    "& svg": {
        transform: "rotate(180deg)"
    }
});

const dropdownStyle = css({
    zIndex: "2003"
});
import {useEffect, useId, useRef, useState} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ManualPopover} from "@pg-design/floating-module";
import {ChevronDownIcon, HeartFillIcon, HeartIcon} from "@pg-design/icons-module";

import {ViewType} from "../../view_type/ViewType";
import {trackFavouritesIconClick} from "../tracking/track_favourites_icon_click";
import {IFavouritesTopbarCard} from "../utils/map_favourite_to_topbar_card";
import {consumePendingFavouritesTopbar} from "../utils/pending_favourites_auth";
import {FavouritesCountBadge} from "./FavouritesCountBadge";
import {FavouritesTopbarDropdown} from "./FavouritesTopbarDropdown";

interface IProps {
    badgeTestId: string;
    buttonTestId: string;
    count: number;
    favouriteLabel: string;
    favouritesListLink: string;
    isAuthenticated: boolean;
    onGuestClick: () => void;
    cards: IFavouritesTopbarCard[];
    showBadge: boolean;
    viewType: ViewType | null;
}

export const FavouritesTopbarDesktop = (props: IProps) => {
    const {badgeTestId, buttonTestId, cards, count, favouriteLabel, favouritesListLink, isAuthenticated, onGuestClick, showBadge, viewType} = props;
    const [isOpen, setIsOpen] = useState(false);
    const dropdownId = useId();
    const rootRef = useRef<HTMLDivElement>(null);
    const triggerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!isAuthenticated) {
            return;
        }

        if (!consumePendingFavouritesTopbar("desktop")) {
            return;
        }

        setIsOpen(true);
    }, [isAuthenticated]);

    useEffect(() => {
        if (!isOpen) {
            return;
        }

        const onPointerDown = (event: PointerEvent) => {
            if (!(event.target instanceof Node) || rootRef.current?.contains(event.target)) {
                return;
            }

            setIsOpen(false);
        };

        const onKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Escape") {
                setIsOpen(false);
                triggerRef.current?.querySelector("button")?.focus();
            }
        };

        document.addEventListener("pointerdown", onPointerDown);
        document.addEventListener("keydown", onKeyDown);

        return () => {
            document.removeEventListener("pointerdown", onPointerDown);
            document.removeEventListener("keydown", onKeyDown);
        };
    }, [isOpen]);

    const handleDesktopButtonClick = () => {
        if (!isAuthenticated) {
            trackFavouritesIconClick();
            onGuestClick();
            return;
        }

        if (!isOpen) {
            trackFavouritesIconClick();
        }

        setIsOpen((open) => !open);
    };

    return (
        <div ref={rootRef}>
            <ManualPopover
                className={dropdownStyle}
                handleSetIsOpen={setIsOpen}
                hideArrow
                isOpen={isOpen}
                placement="bottom-end"
                popover={
                    <FavouritesTopbarDropdown cards={cards} count={count} dropdownId={dropdownId} favouritesListLink={favouritesListLink} viewType={viewType} />
                }
            >
                {({refs, getReferenceProps}) => (
                    <div
                        {...getReferenceProps()}
                        className={desktopTriggerStyle}
                        onClick={(event) => event.stopPropagation()}
                        ref={(node) => {
                            refs.setReference(node);
                            triggerRef.current = node;
                        }}
                    >
                        <Button
                            aria-controls={dropdownId}
                            aria-expanded={isOpen}
                            aria-haspopup="true"
                            aria-label={favouriteLabel}
                            className={desktopButtonStyle}
                            contentClassName={desktopButtonContentStyle}
                            dataTestId={buttonTestId}
                            iconLeft={isOpen ? HeartFillIcon : HeartIcon}
                            iconLeftProps={{
                                fill: "var(--colors-gray-800)",
                                size: "2.4",
                                wrapperColor: "var(--colors-beige-subtle)",
                                wrapperSize: "3.6",
                                wrapperType: "circle"
                            }}
                            iconRight={ChevronDownIcon}
                            iconRightProps={{
                                className: cx(chevronStyle, isOpen && chevronOpenStyle),
                                size: "1",
                                wrapperColor: "var(--colors-white)",
                                wrapperSize: "1.6",
                                wrapperType: "square"
                            }}
                            onClick={handleDesktopButtonClick}
                            type="button"
                            variant="transparent"
                        />
                        {showBadge && <FavouritesCountBadge count={count} dataTestId={badgeTestId} />}
                    </div>
                )}
            </ManualPopover>
        </div>
    );
};

const desktopTriggerStyle = css({
    position: "relative"
});

const desktopButtonStyle = css({
    h: "4rem",
    py: 0,
    pl: 0,
    pr: 2,
    bg: "var(--colors-white)",
    border: "1px solid var(--colors-gray-400)",
    borderRadius: "100px"
});

const desktopButtonContentStyle = css({
    gap: 1,
    "& > span:empty": {
        display: "none"
    }
});

const chevronStyle = css({
    borderRadius: "0.2rem",
    boxShadow: "var(--shadow-1)",
    "& svg": {
        transition: "transform 0.2s ease-in-out"
    }
});

const chevronOpenStyle = css({
    "& svg": {
        transform: "rotate(180deg)"
    }
});

const dropdownStyle = css({
    zIndex: "2003"
});
